var render = function render(){var _vm=this,_c=_vm._self._c;return _c('contribution-event-base',{attrs:{"event":_vm.event,"message":_vm.message,"icon-name":_vm.iconName}})
}
var staticRenderFns = []

export { render, staticRenderFns }